//-------------------------MATERIAL-UI-------------------------//
import { Container, Grid, IconButton, LinearProgress } from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";

//-------------------------REACT-------------------------//
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

//-------------------------THIRD-PARTY-------------------------//
import { isMobile } from "react-device-detect";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import ls from "local-storage";
import { useTranslation } from "react-i18next";

//-------------------------COMPONENTS-------------------------//
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import RequestCard from "../../components/RequestCard/RequestCard";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";

//-------------------------OTHERS-------------------------//
import { getTaskList, getList, getStatusList, getAreaList, getTechnicianList, getCostCenterList } from "../../store/actions/PlannedMaintenanceListActions";
import { StyledGridUl, StyledListItem } from "../BreakdownList/styled";
import { handleStatusName } from "../../common";

const ss = sessionStorage;
const plantId = localStorage.getItem("plantId");

const constants = {
    dataSize: isMobile ? 7 : window.matchMedia("(orientation: portrait)").matches ? 30 : 15,
};

export default function PlannedMaintenanceTaskList(props) {
    const dispatch = useDispatch();
    const location = useLocation();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [userID, setUserID] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [filterCount, setFilterCount] = useState(0);
    const [rowLength, setRowLength] = useState(3);
    const { t } = useTranslation("translation");
    const PlannedMaintenanceList = useSelector((state) => state.PlannedMaintenanceList);
    const { tasklist } = useSelector(({ PlannedMaintenanceList }) => PlannedMaintenanceList);

    //getfirst day of the week
    const getFirstDayOfWeek = (date) => {
        var day = date.getDay(),
            diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return moment(date.setDate(diff)).format("YYYY-MM-DD");
    };

    //get last day of the week
    const getLastDayOfWeek = (date) => {
        var day = date.getDay(),
            diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return moment(date.setDate(diff + 6)).format("YYYY-MM-DD");
    };

    //get first day of the month
    const getFirstDayOfMonth = (date) => {
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        return moment(firstDay).format("YYYY-MM-DD");
    };

    //get last day of the month
    const getLastDayOfMonth = (date) => {
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return moment(lastDay).format("YYYY-MM-DD");
    };

    //set current date
    const setCurrentDate = (date) => {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var modifiedMonth = month <= 9 ? "0" + month : month;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var newStartDate = year + "-" + modifiedMonth + "-" + day;
        return newStartDate;
    };

    useEffect(() => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        setUserID(oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", ""));
        dispatch(getTechnicianList());
        LoadHandler();
        if (isMobile) {
            setRowLength(1);
        }
    }, [plantId]);

    useEffect(() => {
        if (tasklist?.firstCallRes) {
            //works loadhandler
            setRows([]);
            setRows(Object.values(tasklist.firstCallRes.resultObject.content));
            const hasNextPage = tasklist.firstCallRes.resultObject.hasNext;
            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(2);
            }
        }

        if (tasklist?.fetchMoreDataRes) {
            const totalRows = [...rows, ...tasklist.fetchMoreDataRes.resultObject.content];
            setRows(totalRows);

            const hasNextPage = tasklist.fetchMoreDataRes.resultObject.hasNext;
            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(currentPage + 1);
            }
        }

        if (tasklist?.handleTimeRes) {
            setRows([]);
            const hasNextPage = tasklist.handleTimeRes.resultObject.hasNext;
            setRows(tasklist.handleTimeRes.resultObject.content);

            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(2);
            }
        }

        if (tasklist?.applyFilterRes) {
            setRows(tasklist.applyFilterRes.resultObject.content);
            const hasNextPage = tasklist.applyFilterRes.resultObject.hasNext;
            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(2);
            }
        }
    }, [PlannedMaintenanceList.tasklist]);

    useEffect(() => {
        if (PlannedMaintenanceList.poolList) {
            setPoolData(Object.values(PlannedMaintenanceList.poolList));
        }
    }, [PlannedMaintenanceList.poolList]);

    useEffect(() => {
        if (PlannedMaintenanceList.statusList) {
            setStatusData(Object.values(PlannedMaintenanceList.statusList));
            setSelectedStatusName(handleStatusName(Object.values(PlannedMaintenanceList.statusList), state.status));
            setPageLoaded(true);
        }
    }, [PlannedMaintenanceList.statusList]);

    useEffect(() => {
        if (PlannedMaintenanceList.areaList) {
            let areaList = PlannedMaintenanceList.areaList;
            setAreaData(areaList);
        }
    }, [PlannedMaintenanceList.areaList]);

    useEffect(() => {
        if (PlannedMaintenanceList.technicianList) {
            if (PlannedMaintenanceList?.technicianList?.handleCheckedRes) {
                setUserData(Object.values(PlannedMaintenanceList.technicianList)[0]);
            } else {
                setUserData(Object.values(PlannedMaintenanceList.technicianList));
                dispatch(getCostCenterList());
            }
        }
    }, [PlannedMaintenanceList.technicianList]);

    useEffect(() => {
        if (PlannedMaintenanceList.costCenterList) {
            LoadAreaData();
            setCostCenterData(Object.values(PlannedMaintenanceList.costCenterList));
        }
    }, [PlannedMaintenanceList.costCenterList]);

    const [rows, setRows] = useState([]);
    const [poolData, setPoolData] = useState([]);
    const [statusData, setStatusData] = useState([]);

    let [selectedStatusName, setSelectedStatusName] = useState([]);

    let timeIntervals = [
        { id: 1, name: t("Today") },
        { id: 2, name: t("ThisWeek") },
        { id: 3, name: t("ThisMonth") },
        { id: 4, name: t("Manual") },
    ];

    let [selectedTimeInterval, setSelectedTimeInterval] = useState(1);

    //states
    const [state, setState] = useState({
        areaGroupId: null,
        checkedMe: false,
        poolIds: ls.get("pmtl_poolId_" + plantId) || [],
        status: ls.get("pmtl_status") || [1, 2],
        user: ss.getItem("pmtl_user") ? JSON.parse(ss.getItem("pmtl_user")) : [],
        userName: null,
        breakdownReasonGroup: null,
        breakdownEffect: null,
        creatorName: null,
        creatorId: ss.getItem("pmtl_creatorId") ? JSON.parse(ss.getItem("pmtl_creatorId")) : [],
        taskID: 0,
        taskNo: null,
        technicianNote: null,
        callNote: null,
        plannedTimeRange: null,
        planNo: null,
        areaGroupCode: null,
        machineId: null,
        maintenanceNote: null,
        period: 0,
        periodType: null,
        startDate: ls.get("pmtl_startDate") || setCurrentDate(new Date()),
        endDate: ls.get("pmtl_endDate") || setCurrentDate(new Date()),
        selectedCostCenter: null,
        selectedCostCenterId: ss.getItem("pmtl_costCenterId") ? JSON.parse(ss.getItem("pmtl_costCenterId")) : [],
        orderId: 0,
        selectedAreaFilter: ss.getItem("pmtl_areaGroupId") ? JSON.parse(ss.getItem("pmtl_areaGroupId")) : [],
    });

    const LoadHandler = () => {
        state.pool = ls.get("pmtl_poolName_" + plantId) || null;
        //if there are some cached data, then take cached data. If not, take default data.
        setState({
            ...state,
            poolName: ls.get("pmtl_poolName_" + plantId) || null,
            startDate: ls.get("pmtl_plannedTimeRange") != null ? ls.get("pmtl_startDate") : setCurrentDate(new Date()),
            endDate: ls.get("pmtl_plannedTimeRange") != null ? ls.get("pmtl_endDate") : setCurrentDate(new Date()),
            plannedTimeRange: ls.get("blt_interval") || 1,
        });

        let payloadTechList = {
            handleChecked: true,
        };

        dispatch(getTechnicianList(payloadTechList)); //Take technician list to get user id.
        setFilterCount(ss.getItem("ptml_filterCount") > 0 ? ss.getItem("ptml_filterCount") : 0);

        const data = getData();
        let payload = {
            pageSize: constants.dataSize,
            currentPage: currentPage,
            data: data,
            firstCall: true,
        };
        dispatch(getTaskList(payload));

        dispatch(getList());
        dispatch(getStatusList());
    };

    const FetchMoreData = () => {
        const data = getData();

        let payload = {
            data: data,
            currentPage: currentPage,
            pageSize: constants.dataSize,
            fetchMoreData: true,
        };
        dispatch(getTaskList(payload));
    };

    const SetDefaultState = () => {
        setState({
            areaGroupId: null,
            checkedMe: state.checkedMe ? true : false, //stays true if it was true before
            poolIds: ls.get("pmtl_poolId_" + plantId) || [],
            status: ls.get("pmtl_status") || [1, 2],
            user: [],
            userName: null,
            breakdownReasonGroup: null,
            breakdownEffect: null,
            creatorName: null,
            creatorId: [],
            taskID: 0,
            technicianNote: null,
            callNote: null,
            plannedTimeRange: state.plannedTimeRange,
            areaGroupCode: null,
            machineId: null,
            maintenanceNote: null,
            period: 0,
            periodType: null,
            startDate: ls.get("pmtl_startDate") || setCurrentDate(new Date()),
            endDate: ls.get("pmtl_endDate") || setCurrentDate(new Date()),
            selectedCostCenter: null,
            selectedCostCenterId: [],
            orderId: 0,
            selectedAreaFilter: [],
        });
    };

    const HandleAssignToMe = (event) => {
        state.checkedMe = event.target.checked;
        const userInfo = userData.filter((item) => item.userCode == userID); //"26001756"
        setState({ ...state, checkedMe: event.target.checked });
        ls.set("pmtl_localuser", userInfo[0].id);
        HandleApplyFilter();
    };
    //set status
    const HandleStatus = (event) => {
        setState({ ...state, status: event.target.value });
        setSelectedStatusName(handleStatusName(statusData, event.target.value));
        ls.set("pmtl_status", event.target.value);
    };

    //set pool
    const HandlePool = (poolName) => {
        let ids = [];
        poolName.map((item) => ids.push(item.id));
        setState({ ...state, poolIds: ids });
        ls.set("pmtl_poolId_" + plantId, ids);
    };

    //set userId and userName
    const HandleUser = (userName) => {
        let ids = [];
        userName.map((item) => ids.push(item.id));
        if (userName == null) {
            ss.removeItem("pmtl_user");
        } else {
            ss.setItem("pmtl_user", JSON.stringify(ids));
        }
        setState({ ...state, user: ids });
    };

    // set creator for filter
    const HandleCreatorName = (creatorName) => {
        let ids = [];
        creatorName.map((item) => ids.push(item.id));
        if (creatorName == null) {
            ss.removeItem("pmtl_creatorId");
        } else {
            ss.setItem("pmtl_creatorId", JSON.stringify(ids));
        }
        setState({ ...state, creatorId: ids });
    };

    //set start date
    const HandleStartDate = (date) => {
        setState({ ...state, startDate: setCurrentDate(date) });
        ls.set("pmtl_startDate", date);
    };

    //set end date
    const HandleEndDate = (date) => {
        setState({ ...state, endDate: setCurrentDate(date) });
        ls.set("pmtl_endDate", date);
    };

    //detail popup
    const [userData, setUserData] = useState([]);
    const [costCenterData, setCostCenterData] = useState([]);

    //set filtered array with conditions
    const FilterWithID = (e) => {
        setState({ ...state, taskID: e.target.value });
        ss.setItem("pmtl_taskNo", e.target.value);
    };

    const FilterWithMaintenanceNote = (e) => {
        setState({ ...state, maintenanceNote: e.target.value });
        ss.setItem("pmtl_maintenanceNote", e.target.value);
    };

    const FilterWithCallNote = (e) => {
        setState({ ...state, callNote: e.target.value });
        ss.setItem("pmlt_workingNote", e.target.value);
    };

    const FilterOrderId = (e) => {
        setState({ ...state, orderId: e.target.value });
        ss.setItem("pmtl_planNo", e.target.value);
    };

    const HandleCostCenterChange = (costCenter) => {
        let ids = [];
        costCenter.map((item) => ids.push(item.id));
        if (costCenter == null) {
            ss.removeItem("pmtl_costCenterId");
        } else {
            ss.setItem("pmtl_costCenterId", JSON.stringify(ids));
        }
        setState({ ...state, selectedCostCenterId: ids });
    };

    const HandleAreaFilterChange = (areaName) => {
        let ids = [];
        areaName.map((item) => ids.push(item.id));
        if (areaName == null) {
            ss.removeItem("pmtl_areaGroupId");
        } else {
            ss.setItem("pmtl_areaGroupId", JSON.stringify(ids));
        }
        setState({ ...state, selectedAreaFilter: ids });
    };

    //load area data for popup
    let [areaData, setAreaData] = useState([]);
    const LoadAreaData = () => {
        dispatch(getAreaList());
    };

    const HandleTimeSelection = (id) => {
        switch (id) {
            case 1: //gün
                SetDatesAndRange(setCurrentDate(new Date()), setCurrentDate(new Date()));
                break;
            case 2: //hafta
                SetDatesAndRange(getFirstDayOfWeek(new Date()), getLastDayOfWeek(new Date()));
                break;
            case 3: //ay
                SetDatesAndRange(getFirstDayOfMonth(new Date()), getLastDayOfMonth(new Date()));
                break;
            default:
                SetDatesAndRange(setCurrentDate(new Date()), setCurrentDate(new Date()));
                break;
        }
    };

    // set timeInterval
    const HandleTimeInterval = (e) => {
        setSelectedTimeInterval(e.target.value);
        ls.set("blt_interval", e.target.value);
        HandleTimeSelection(e.target.value);

        const data = getData();

        let payload = {
            pageSize: constants.dataSize,
            currentPage: 1,
            data: data,
            handleTime: true,
        };
        dispatch(getTaskList(payload));
    };

    const SetDatesAndRange = (start, end, range) => {
        state.startDate = start;
        state.endDate = end;
        setState({ ...state, startDate: start, endDate: end, plannedTimeRange: range });

        ls.set("pmtl_startDate", start);
        ls.set("pmtl_endDate", end);
        ls.set("pmtl_plannedTimeRange", range);
    };

    // Machine popup
    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "pmtl",
            selectedAreaCode: isCleared ? null : ss.getItem("pmtl_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("pmtl_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("pmtl_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("pmtl_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("pmtl_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("pmtl_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);
    const HandleClearMachineStates = () => {
        ss.removeItem("pmtl_selectedAreaCode");
        ss.removeItem("pmtl_selectedAreaName");
        ss.removeItem("pmtl_selectedMainEquipmentCode");
        ss.removeItem("pmtl_selectedMainEquipmentName");
        ss.removeItem("pmtl_selectedSubEquipmentCode");
        ss.removeItem("pmtl_selectedSubEquipmentName");
        setMachineStates(initialMachineStates(true));
    };

    const HandleClearFilter = () => {
        ls.set("pmtl_status", []);
        ls.set("pmtl_poolId_" + plantId, []);
        ls.set("blt_interval", 1);
        ls.set("pmtl_startDate", setCurrentDate(new Date()));
        ls.set("pmtl_endDate", setCurrentDate(new Date()));

        HandleClearMachineStates();
        SetDefaultState();

        ss.clear();
        HandleApplyFilter(true);
        setFilterCount(0);
    };

    const getData = (isFilterCleared = false) => {
        return {
            startDate: isFilterCleared ? setCurrentDate(new Date()) : state.startDate,
            endDate: isFilterCleared ? setCurrentDate(new Date()) : state.endDate,
            statusArr: ls.get("pmtl_status") ? ls.get("pmtl_status").toString() : [1, 2].toString(),
            poolIds: ls.get("pmtl_poolId_" + plantId) || [],
            assigneedIds: state.checkedMe ? [ls.get("pmtl_localuser")] : ss.getItem("pmtl_user") ? JSON.parse(ss.getItem("pmtl_user")) : [],
            creatorIds: ss.getItem("pmtl_creatorId") ? JSON.parse(ss.getItem("pmtl_creatorId")) : [],
            costCenterIds: ss.getItem("pmtl_costCenterId") ? JSON.parse(ss.getItem("pmtl_costCenterId")) : [],
            areaGroupIds: ss.getItem("pmtl_areaGroupId") ? JSON.parse(ss.getItem("pmtl_areaGroupId")) : [],
            taskId: ss.getItem("pmtl_taskNo") ? parseInt(ss.getItem("pmtl_taskNo")) : 0,
            orderId: ss.getItem("pmtl_planNo") ? parseInt(ss.getItem("pmtl_planNo")) : 0,
            taskNote: ss.getItem("pmtl_maintenanceNote") ? ss.getItem("pmtl_maintenanceNote") : null,
            orderNote: ss.getItem("pmlt_workingNote") ? ss.getItem("pmlt_workingNote") : null,
            machineId: location.state?.equipmentId ?? isFilterCleared ? 0 : machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            maintenanceTypeIds: [],
        };
    };

    const HandleApplyFilter = (isFilterCleared = false) => {
        setRows([]);
        const data = getData(isFilterCleared);

        let payload = {
            pageSize: constants.dataSize,
            currentPage: 1,
            data: data,
            applyFilter: true,
        };

        dispatch(getTaskList(payload));
    };

    const goBackToEquipmentNotes = () => {
        props.history.goBack();
    };

    const equipmentNotesBackArrow = () => {
        if (location.state?.equipmentId) {
            return (
                <Grid id="pmtl_icnBckGrid" item xs={1} style={{ marginTop: 20 }}>
                    <IconButton id="pmtl_iconBckBtn" onClick={goBackToEquipmentNotes}>
                        <ArrowBackIos id="pmtl_arrowBack" fontSize="inherit" align="center" />
                    </IconButton>
                </Grid>
            );
        } else {
            return null;
        }
    };

    const HandleRowLength = (event) => {
        if (event.target.value != "") {
            setRowLength(event.target.value);
            if (event.target.value > 5) {
                FetchMoreData();
            }
        }
    };

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }

        setIsFilterDrawerOpen(open);
    };

    const filter = () => {
        return (
            <DetailFilter
                HandleTimeInterval={HandleTimeInterval}
                selectedTimeInterval={ls.get("blt_interval") || selectedTimeInterval}
                timeIntervals={timeIntervals}
                HandleAssignToMe={HandleAssignToMe}
                HandleRowLength={HandleRowLength}
                HandleStatus={HandleStatus}
                statusData={statusData}
                status={state.status}
                selectedStatusName={selectedStatusName}
                HandlePool={HandlePool}
                poolData={poolData}
                poolIds={state.poolIds}
                HandleUser={HandleUser}
                isMultipleAssigned={true}
                userData={userData}
                userName={state.user}
                HandleCreatorName={HandleCreatorName}
                isMultipleDeclarative={true}
                creatorName={state.creatorId}
                HandleCostCenterChange={HandleCostCenterChange}
                costCenterData={costCenterData}
                selectedCostCenterId={state.selectedCostCenterId}
                HandleAreaFilterChange={HandleAreaFilterChange}
                isMultipleAreaGroup={true}
                areaData={areaData}
                selectedAreaFilter={state.selectedAreaFilter}
                FilterWithID={FilterWithID}
                taskId={state.taskID}
                FilterPlanId={FilterOrderId}
                selectedPlanId={state.orderId}
                FilterWithMaintenanceNote={FilterWithMaintenanceNote}
                maintenanceNote={state.maintenanceNote}
                FilterWithPlanNote={FilterWithCallNote}
                planNote={state.callNote}
                HandleStartDate={HandleStartDate}
                startDate={state.startDate}
                HandleEndDate={HandleEndDate}
                endDate={state.endDate}
                setMachineStates={setMachineStates}
                machineStates={machineStates}
                isAreaNotFiltered={true}
            />
        );
    };

    return (
        <div>
            {pageLoaded === true ? (
                <Grid id="pml_Grid0" style={{ marginTop: 20, marginLeft: 20, marginRight: 20 }}>
                    <Container id="pml_Container">
                        <FilterDrawer
                            open={isFilterDrawerOpen}
                            onOpen={toggleDrawer(true)}
                            onClose={toggleDrawer(false)}
                            HandleClearFilter={HandleClearFilter}
                            HandleApplyFilter={() => {
                                setIsFilterDrawerOpen(false);
                                HandleApplyFilter();
                            }}
                            detailFilter={filter()}
                        />
                        <FilterButton onClick={() => toggleDrawer(true)} />
                    </Container>
                    <Grid id="pml_Grid_6">
                        <InfiniteScroll
                            id="pml_InfiniteScroll"
                            dataLength={rows.length} //This is important field to render the next data
                            next={FetchMoreData}
                            hasMore={hasMore}
                            loader={rows.length > 15 ? <LinearProgress id="pml_LinearProgress" /> : null}
                            endMessage={
                                rows.length == 0 ? (
                                    <p style={{ textAlign: "center" }}>
                                        <b>{t("ThereIsNoRecord")}</b>
                                    </p>
                                ) : (
                                    <p style={{ textAlign: "center" }}>
                                        <b>{t("YouHaveSeenItAll")}</b>
                                    </p>
                                )
                            }
                        >
                            <StyledGridUl rows rowLength={rowLength} id="pml_StyledGridUl">
                                {rows.map((row, index) => {
                                    return (
                                        <StyledListItem id="pml_StyledListItem">
                                            <li id={`pml_li_${index}`} key={index} style={{ margin: "5px" }}>
                                                <RequestCard id="pml_RequestCard" rows={[row]} detail={false} isPlannedMaintenance={true} page="plannedmaintenance" />
                                            </li>
                                        </StyledListItem>
                                    );
                                })}
                            </StyledGridUl>
                        </InfiniteScroll>
                    </Grid>
                </Grid>
            ) : null}

            <LoadingBackdrop id="pml_LoadingBackdrop" />
        </div>
    );
}
